import React, { useContext } from "react";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import Headline from "~/assets/js/components/Typography/Headline";
import Button from "~/assets/js/components/Button";
import { Edit2 } from "react-feather";
import { CheckoutContext, ACTIONS } from "../../CheckoutProvider";

const OverviewSection = ({ title, titleOptions, editPage, children }) => {
    const { dispatch } = useContext(CheckoutContext);

    const changePage = () => {
        if (typeof editPage === "string") {
            dispatch({ type: ACTIONS.CHANGE_PAGE, payload: editPage });
        } else if (typeof editPage === "function") {
            editPage();
        }
    };

    return (
        <div className="overview__section">
            {title && (
                <div className="overview__header ">
                    <Headline resizable size={6}>
                        {i18n.t(title, titleOptions)}
                    </Headline>
                    {!!editPage && (
                        <Button
                            onClick={changePage}
                            label={i18n.t("overview.edit")}
                            variant="secondary"
                            size="XS"
                            icon={<Edit2 size={18} />}
                        />
                    )}
                </div>
            )}

            {children}
            <hr className="overview__divider" />
        </div>
    );
};

OverviewSection.propTypes = {
    title: PropTypes.string,
    titleOptions: PropTypes.object,
    editPage: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

OverviewSection.defaultProps = {
    titleOptions: {},
};

OverviewSection.propTypes = {
    title: PropTypes.string,
    titleOptions: PropTypes.object,
    editPage: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default OverviewSection;
